import { takeEvery, call, put, select } from "redux-saga/effects";
import { GET_SECTIONS } from "store/actionTypes";
import { GetDocService } from "store/services/document";

// watchers
export function* GetSectionsWatcher() {
  yield takeEvery(GET_SECTIONS.WATCH, GetSectionsWorker);
}

// workers
export function* GetSectionsWorker({ payload }) {
  try {
    yield put({ type: GET_SECTIONS.LOAD });
    const response = yield call(GetDocService, payload);
    yield put({ type: GET_SECTIONS.SUCCESS, payload: response });
  } catch (e) {
    yield put({ type: GET_SECTIONS.FAIL, message: e.message });
  }
}
